import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#666",
      "fill-rule": "nonzero",
      d: "M1.925 0h8.4c1.063 0 1.925.862 1.925 1.925v10.15A1.925 1.925 0 0 1 10.325 14h-8.4A1.925 1.925 0 0 1 0 12.075V1.925C0 .862.862 0 1.925 0m0 1.05a.875.875 0 0 0-.875.875v10.15a.875.875 0 0 0 .875.875h8.4a.875.875 0 0 0 .875-.875V1.925a.875.875 0 0 0-.875-.875zm2.8 10.15a.525.525 0 1 1 0-1.05h2.8a.525.525 0 1 1 0 1.05z"
    }, null, -1)
  ])))
}
export default { render: render }